import React, { useEffect, useRef, useState } from 'react';

type CountdownTimerProps = {
    durationSeconds: number;
    onTimeout: () => void;
    stopped?: boolean;
};

const CountdownTimer: React.FC<CountdownTimerProps> = ({ durationSeconds, onTimeout, stopped = false }) => {
    const [timeLeft, setTimeLeft] = useState(durationSeconds);
    const requestRef = useRef<number>();
    const startTimeRef = useRef<number>();
    const hasCalledTimeout = useRef(false);

    const animate = (time: number) => {
        if (stopped) return; // 👈 Early return if manually stopped

        if (!startTimeRef.current) startTimeRef.current = time;
        const elapsed = (time - startTimeRef.current) / 1000;
        const remaining = Math.max(0, durationSeconds - elapsed);
        setTimeLeft(remaining);

        if (remaining > 0) {
            requestRef.current = requestAnimationFrame(animate);
        } else {
            if (!hasCalledTimeout.current) {
                hasCalledTimeout.current = true;
                onTimeout();
            }
        }
    };

    useEffect(() => {
        if (!stopped) {
            requestRef.current = requestAnimationFrame(animate);
        }

        return () => {
            if (requestRef.current) cancelAnimationFrame(requestRef.current);
        };
    }, [stopped, durationSeconds, onTimeout]);

    return (
        <div>
            <h2 style={{ margin: 0 }}>Time Left: {timeLeft.toFixed(1)}s</h2>
        </div>
    );
};

export default CountdownTimer;
